"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinusControl = exports.PlusControl = exports.NumberControls = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.NumberControls = styled_components_1.default.div `
  height: 100%;
  border-left: 1px solid ${props => props.theme.palette.LIGHT_GRAY_90};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
exports.PlusControl = styled_components_1.default.div `
  width: ${props => props.theme.constants.blockWidth.s4}px;
  height: 50%;
  background: ${props => props.theme.palette.LIGHT_GRAY_20};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom: 1px solid ${props => props.theme.palette.LIGHT_GRAY_90};
  border-top-right-radius: ${props => props.theme.spacing.s1}px;

  :hover {
    background: ${props => props.theme.palette.BLUE_GRAY_20};
  }
`;
exports.MinusControl = styled_components_1.default.div `
  width: ${props => props.theme.constants.blockWidth.s4}px;
  height: 50%;
  background: ${props => props.theme.palette.LIGHT_GRAY_20};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom-right-radius: ${props => props.theme.spacing.s1}px;

  > svg {
    transform: rotate(180deg);
  }

  :hover {
    background: ${props => props.theme.palette.BLUE_GRAY_20};
  }
`;
exports.default = {
    NumberControls: exports.NumberControls,
    PlusControl: exports.PlusControl,
    MinusControl: exports.MinusControl
};
